<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async sendEmail(event) {
      event.preventDefault();
      
      if (this.isLoading) return;
      
      const form = this.$refs.form;
      const formData = new FormData(form);
      
      // Obtener los valores del formulario
      const data = {
        con_name: formData.get('con_name') || '',
        con_email: formData.get('con_email') || '',
        con_telefono: formData.get('con_telefono') || '',
        con_message: formData.get('con_message') || ''
      };

      // Validación básica
      if (!data.con_name.trim() || !data.con_email.trim() || !data.con_message.trim()) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor completa todos los campos obligatorios (Nombre, Email y Mensaje).",
        });
        return;
      }

      // Validar formato de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.con_email)) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor ingresa un email válido.",
        });
        return;
      }

      this.isLoading = true;

      try {
        // Obtener la URL de la Cloud Function
        // En desarrollo, puedes usar: http://localhost:5001/paginasibsmx/us-central1/sendContactEmail
        // En producción, Firebase generará la URL automáticamente
        const functionUrl = 'https://us-central1-paginasibsmx.cloudfunctions.net/sendContactEmail';
        
        const response = await fetch(functionUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        });

        const result = await response.json();

        if (response.ok && result.success) {
          Swal.fire({
            icon: "success",
            title: "¡Mensaje enviado!",
            text: "En un momento un asesor se comunicará contigo.",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            // Limpiar el formulario
            form.reset();
            // Opcional: redirigir a inicio
            // this.$router.push('/');
          });
        } else {
          throw new Error(result.error || 'Error al enviar el mensaje');
        }
      } catch (error) {
        console.error('Error:', error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al enviar tu mensaje. Por favor, intenta nuevamente o contáctanos directamente a contacto@ibsconsultores.com",
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<template>
  <div>
    <!-- CONTACT FORM START-->
    <section class="section" id="contact">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 offset-lg-2">
            <h1 class="section-title text-center">CONTACTO</h1>
            <div class="section-title-border margin-t-20"></div>
            <p class="section-subtitle text-muted text-center font-secondary padding-t-30">Si tienes alguna duda o
              inquietud, puedes pedir asesoría con
              nuestros expertos.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="mt-4 pt-4">
              <p class="mt-4">
                <span class="h5">DIRECCIÓN:</span>
                <br />
                <span class="text-muted d-block mt-2">González Cossio 3703
                  Col. Granjas Chihuahua, Chih.</span>
              </p>
              <p class="mt-4">
                <span class="h5">HORARIO:</span>
                <br />
                <span class="text-muted d-block mt-2">Lunes a Viernes: 8:30AM A 6:00PM</span>
                <span class="text-muted d-block mt-2">Sabados: 9:00AM A 1:00PM</span>
                <span class="text-muted d-block mt-2">Domingos: CERRADO</span>
              </p>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="custom-form mt-4 pt-4">
              <div id="message"></div>
              <form id="contact-form" ref="form" @submit.prevent="sendEmail">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group mt-2">
                      <input name="con_name" type="text" class="form-control" placeholder="Nombre*" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group mt-2">
                      <input name="con_email" type="email" class="form-control" placeholder="Email*" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group mt-2">
                      <input type="text" name="con_telefono" class="form-control" id="subject" placeholder="Télefono.." />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group mt-2">
                      <textarea name="con_message" id="comments" rows="4" class="form-control"
                        placeholder="Tu mensaje..."></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 text-right">
                    <button type="submit" id="submit" name="send" class="submitBnt btn btn-custom" 
                      :disabled="isLoading">
                      <span v-if="isLoading">Enviando...</span>
                      <span v-else>Enviar Mensaje</span>
                    </button>
                    <div id="simple-msg"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- CONTACT FORM END-->

    <!--START SOCIAL-->
    <section class="cta bg-light">
      <div class="container">
        <div class="row">
          <div class="col-lg-4">
            <ul class="list-inline social margin-t-20">
              <li class="list-inline-item">
                <a target="_blank" href="https://www.facebook.com/voysegurousa" class="social-icon">
                  <i class="mdi mdi-facebook"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a target="_blank" href="https://twitter.com/VoySeguroUSA" class="social-icon">
                  <i class="mdi mdi-twitter"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a target="_blank" href="https://www.instagram.com/voysegurousa/" class="social-icon">
                  <i class="mdi mdi-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-4 margin-t-30">
            <p class="margin-b-0 contact-title">
              <i class="pe-7s-call"></i> &nbsp; 800 777 0911
            </p>
          </div>
          <div class="col-lg-4 margin-t-30">
            <p class="margin-b-0 contact-title">
              <i class="pe-7s-mail-open"></i>&nbsp; contacto@ibsconsultores.com
            </p>
          </div>
        </div>
      </div>
    </section>
    <!--END SOCIAL-->
  </div>
</template>